import React, { ReactElement, useEffect } from 'react';

import { Breadcrumbs, homeBreadcrumb } from 'slovlex-idsk-react-components';
import { useLocation } from 'react-router';
import TezaurusCreateForm from '../../../module/Admin/Tezaurus/Create/TezaurusCreateForm';
import GlobalErrors from '../../../module/GlobalErrors';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import routes from '../../../routing/routes';
import Layout from '../../Layout';
import SecuredPage from '../../../module/SecuredPage';
import UserRoleEnum from '../../../model/currentuser/UserRole';

const TezaurusCreatePage = (): ReactElement => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.parent.postMessage({
      type: 'iframe-to-parent-set-title',
      title: 'Nový tezaurus',
    }, '*');
  }, []);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          to: routes.tezaurus.admin.list,
          heading: 'Administrácia tezaurov',
        },
        {
          to: pathname,
          heading: 'Nový tezaurus',
        },
      ]}
      />
      <GlobalErrors />
      <SecuredPage
        allowForRoles={[UserRoleEnum.ADMINISTRATOR_TEZAURUS]}
      >
        <>
          <PageHeadingWithBackButton heading="Nový tezaurus" />
          <TezaurusCreateForm />
        </>
      </SecuredPage>
    </Layout>
  );
};
export default TezaurusCreatePage;
